import t from 'react-translate';
import { AIFeedbackErrorStatus } from 'redux/schemas/models/submissions';

const FEEDBACK_ERROR_CODES = [500, 502, 504, 404];

export const isInternalErrorCode = (code: number | undefined): boolean => !!code && FEEDBACK_ERROR_CODES.includes(code);

type Params = {
  responseCode: number | undefined;
  statusErrorMessage: string | undefined;
  isLearnerView: boolean;
};

const getErrorMessage = ({ responseCode, statusErrorMessage, isLearnerView }: Params): string => {
  if (isInternalErrorCode(responseCode)) {
    return t.SUBMISSIONS.AI_ASSIGNMENT.UNAVAILABLE_STATE.DESCRIPTION();
  }

  const errorMessages: Record<string, string> = {
    [AIFeedbackErrorStatus.SUBMISSION_TOO_SHORT]: isLearnerView
      ? t.SUBMISSIONS.AI_ASSIGNMENT.AI_INSIGHT.LACK_OF_CONTENT()
      : t.SUBMISSIONS.AI_ASSIGNMENT.LACK_OF_CONTENT(),
    [AIFeedbackErrorStatus.SUBMISSION_WITH_INVALID_TYPE]: isLearnerView
      ? t.SUBMISSIONS.AI_ASSIGNMENT.AI_INSIGHT.INVALID_TYPE()
      : t.SUBMISSIONS.AI_ASSIGNMENT.LACK_OF_CONTENT(),
    [AIFeedbackErrorStatus.CONTENT_IS_TOO_SHORT]: t.SUBMISSIONS.AI_ASSIGNMENT.LACK_OF_COURSE_CONTENT(),
  };

  return statusErrorMessage ? (errorMessages[statusErrorMessage] ?? statusErrorMessage) : '';
};

export default getErrorMessage;
